import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faArrowRightFromBracket,
  faCheck,
  faCopy,
  faEnvelope,
  faUser,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuthDispatch, useAuthState } from "./GlobalContext.jsx";
import toast from "react-hot-toast";

function DropDownMenu() {
  const AuthDispatch = useAuthDispatch();
  const AuthState = useAuthState();
  const [showMenu, setShowMenu] = useState(false);
  const [copied, setCopied] = useState(false);
  const navigate = useNavigate();

  const student = AuthState.userData?.student;
  const parentId = student?.parent_id;
  const fullName = [student?.first_name, student?.second_name, student?.third_name]
    .filter(Boolean)
    .join(" ");

  function handleSignOut() {
    setShowMenu(false);
    localStorage.removeItem("userData");
    AuthDispatch({ type: "setUserData", payload: null });
    navigate("/signin");
  }

  async function handleCopyParentId(e) {
    e.stopPropagation();
    if (!parentId) return;

    try {
      await navigator.clipboard.writeText(String(parentId));
      setCopied(true);
      toast.success("Parent ID copied");
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("Failed to copy");
    }
  }

  return (
    <>
      {showMenu && (
        <div
          className="student-menu__backdrop"
          onClick={() => setShowMenu(false)}
        />
      )}

      <div className="student-menu">
        <button
          type="button"
          className="student-menu__trigger"
          onClick={() => setShowMenu(!showMenu)}
          aria-expanded={showMenu}
        >
          <span className="student-menu__avatar">
            <span className="student-menu__avatar-photo">
              <img
                src={`https://api.our-matrix.com/uploads/profile_picture/${student?.profile_pic}`}
                alt={fullName || "user"}
              />
            </span>
          </span>
          <FontAwesomeIcon
            icon={faAngleDown}
            className={`student-menu__chevron ${showMenu ? "is-open" : ""}`}
          />
        </button>

        {showMenu && (
          <div
            className="student-menu__panel"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="student-menu__profile"
              onClick={() => {
                navigate("/home/profile/");
                setShowMenu(false);
              }}
            >
              <span className="student-menu__avatar student-menu__avatar--lg">
                <span className="student-menu__avatar-photo">
                  <img
                    src={`https://api.our-matrix.com/uploads/profile_picture/${student?.profile_pic}`}
                    alt={fullName || "user"}
                  />
                </span>
              </span>
              <span className="student-menu__profile-meta">
                <span className="student-menu__name">{fullName}</span>
                <span className="student-menu__hint">View profile</span>
              </span>
            </button>

            <div className="student-menu__divider" />

            <Link
              to="/home/my-wallet"
              className="student-menu__item"
              onClick={() => setShowMenu(false)}
            >
              <FontAwesomeIcon icon={faWallet} />
              <span>My Wallet</span>
            </Link>

            <div className="student-menu__meta">
              <div className="student-menu__meta-row">
                <FontAwesomeIcon icon={faEnvelope} />
                <div>
                  <span className="student-menu__meta-label">Email</span>
                  <p className="student-menu__meta-value">{student?.email}</p>
                </div>
              </div>

              <div className="student-menu__meta-row">
                <FontAwesomeIcon icon={faUser} />
                <div className="student-menu__parent">
                  <span className="student-menu__meta-label">Parent ID</span>
                  <div className="student-menu__parent-row">
                    <p className="student-menu__meta-value">{parentId}</p>
                    <button
                      type="button"
                      className="student-menu__copy"
                      onClick={handleCopyParentId}
                      aria-label="Copy Parent ID"
                      title="Copy Parent ID"
                    >
                      <FontAwesomeIcon icon={copied ? faCheck : faCopy} />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="student-menu__divider" />

            <button
              type="button"
              className="student-menu__logout"
              onClick={handleSignOut}
            >
              <FontAwesomeIcon icon={faArrowRightFromBracket} />
              <span>Log out</span>
            </button>
          </div>
        )}
      </div>
    </>
  );
}

export default DropDownMenu;
